import React, {
  useEffect,
  useState,
  Suspense,
  lazy,
} from 'react'
import './App.css'
import './Animations.scss'
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom'
import { ThemeProvider } from '@emotion/react'
import theme from './utils/themes/mainTheme'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import PermissionsProvider from './components/PermissionsProvider/PermissionsProvider'
// import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute' // ОТКЛЮЧЕНО: права до backend
// import { SUPPLIERS__LIST } from './constants/SuppliersList'
import { useSuppliersList } from './constants/SuppliersList'

import { mainApi } from './store/services/mainApi'
import LoadingFallback from './components/UI/LoadingFallback/LoadingFallback'

// Critical components - load immediately
import Header from './components/Header/Header'
import Autorization from './components/Autorization/Autorization'
import PrezoPage from "./components/PrezoPage/prezoPage";


// Lazy load route components for code splitting
const Orders = lazy(
  () => import('./components/Orders/Orders'),
)
const Contacts = lazy(
  () => import('./components/Contacts/Contacts'),
)
const ContactChange = lazy(
  () =>
    import(
      './components/Contacts/ContactChange/ContactChange'
    ),
)
const OrdersChange = lazy(
  () =>
    import('./components/Orders/OrdersChange/OrdersChange'),
)
const Catalog = lazy(
  () => import('./components/Catalog/Catalog'),
)
const CatalogMacroCompare = lazy(
  () =>
    import(
      './components/Catalog/CatalogMacroCompare'
    ),
)
const CatalogChange = lazy(
  () =>
    import(
      './components/Catalog/CatalogChange/CatalogChange'
    ),
)
const History = lazy(
  () => import('./components/History/History'),
)
const StaticPage = lazy(
  () => import('./components/StaticPage/StaticPage'),
)
const OrdersHistory = lazy(
  () =>
    import(
      './components/Orders/OrdersHistory/OrdersHistory'
    ),
)
const Profile = lazy(
  () => import('./components/Profile/Profile'),
)
const ShipmentOrders = lazy(
  () => import('./components/Shipment/ShipmentOrders'),
)
const JuiceProduction = lazy(
  () => import('./components/Juice/JuiceProduction'),
)
const StaticOrderFP = lazy(() =>
  import(
    './components/StaticOrder/StaticOrderFP/StaticOrderFP'
  ).then((module) => ({ default: module.StaticOrderFP })),
)
const WelcomePage = lazy(
  () => import('./components/WelcomePage/WelcomePage'),
)
const ContactStats = lazy(() =>
  import(
    './components/Contacts/ContactStats/ContactStats'
  ).then((module) => ({ default: module.ContactStats })),
)
const LogsPage = lazy(
  () => import('./components/LogsPage/LogsPage'),
)
const CatalogStats = lazy(
  () => import('./components/CatalogStats/CatalogStats'),
)
const ItemsProduction = lazy(
  () =>
    import('./components/ItemsOperecion/ItemsProduction'),
)
const NoAccess = lazy(
  () => import('./components/NoAccess/NoAccess'),
)
const TestFunc = lazy(
  () => import('./components/TESTFUNC/TestFunc'),
)
const SpoManager = lazy(
  () => import('./components/SPOManager/SpoManager'),
)
const prezoPage = lazy(
    () => import('./components/PrezoPage/prezoPage'),
)
const BuyerProduction = lazy(
  () =>
    import('./components/BuyerOperecion/BuyerProduction'),
)
const LowProfit = lazy(
  () => import('./components/LowProfit/LowProfit'),
)
const MBAppPage = lazy(
  () => import('./components/MBAppPage/MBAppPage'),
)
const ProductsManager = lazy(
  () =>
    import('./components/ProductsManager/ProductsManager'),
)
const ProductsManagerHistory = lazy(
    () =>
        import('./components/ProductsManager/ProductsManagerHistory/ProductsManagerHistory'),
)
const StockProduction = lazy(
  () =>
    import('./components/StockOperacion/StockProduction'),
)
const Logistic = lazy(() =>
  import('./components/Logistic/Logistic').then(
    (module) => ({
      default: module.Logistic,
    }),
  ),
)
const SuppliersProduction = lazy(
  () =>
    import(
      './components/SuppliersProduction/SuppliersProduction'
    ),
)
const SalesForCom = lazy(
  () => import('./components/SalesForCom/SalesForCom'),
)
const MessagesPage = lazy(
  () => import('./components/Messages/MessagesPage'),
)
const BuyerListProduction = lazy(
  () =>
    import(
      './components/BuyerListProduction/BuyerListProduction'
    ),
)
const PickingPage = lazy(
  () => import('./components/PickingPage/PickingPage.jsx'),
)
const SearchingListPage = lazy(
  () => import('./components/SearchingListPage/SearchingListPage.jsx'),
)
const DebtorsPage = lazy(
  () => import('./components/DebtorsPage/DebtorsPage'),
)
const SuppliersDebtorsPage = lazy(
  () =>
    import(
      './components/SuppliersDebtorsPage/SuppliersDebtorsPage'
    ),
)
const LogisticHistory = lazy(
  () =>
    import(
      './components/LogisticHistory/LogisticHistory.jsx'
    ),
)
const ResultsPage = lazy(
  () => import('./components/ResultsPage/ResultsPage.jsx'),
)
const BotTimer = lazy(
  () => import('./components/BotTimer/BotTimer'),
)
const MagicButton = lazy(
    () => import('./components/MagicButton/MagicButton'),
)

const MeetingPage = lazy(
  () => import('./components/MeetingPage/MeetingPage.jsx'),
)
const Vacation = lazy(
  () => import('./components/Vacation/Vacation.jsx'),
)
const Management = lazy(
  () => import('./components/Management/Management.jsx'),
)
const TelegramVisitsMap = lazy(
  () =>
    import(
      './components/TelegramVisitsMap/TelegramVisitsMap.jsx'
    ),
)

function App() {

  const { SUPPLIERS_LIST, isLoading } = useSuppliersList()

  const loginObj = {
    VPF: 'aHreSEqUAgRa',
    TPO: 'URoSIBInGLIs',
  }
  const location = useLocation()
  const [name, setName] = useState(
    localStorage.getItem('name') || '',
  )
  const [password, setPassword] = useState(
    localStorage.getItem('password') || '',
  )
  const [isAutorization, setIsAutorization] = useState(
    localStorage.getItem('password') ===
      loginObj[localStorage.getItem('name')] || false,
  )

  const getAccSafe = () => {
    try {
      const raw = localStorage.getItem('acc')
      if (!raw) return null
      return JSON.parse(raw)
    } catch (e) {
      return null
    }
  }

  const acc = getAccSafe()

  const allowedRoutesRaw = Array.isArray(acc?.allowedRoutes)
    ? acc.allowedRoutes
    : null
  const allowedRoutes =
    allowedRoutesRaw
      ?.filter((v) => typeof v === 'string')
      .map((v) => v.trim())
      .filter(Boolean) ?? null

  const isRouteRestricted = !!(
    allowedRoutes && allowedRoutes.length > 0
  )

  const ALWAYS_ALLOWED_ROUTES = new Set([
    '/admin/noAccess',
    '/admin/profile',
    '/welcome',
  ])

  const routeToBasePath = (routePath) => {
    if (typeof routePath !== 'string') return ''
    // Convert route patterns like "/admin/orders/:id" -> "/admin/orders"
    return routePath.replace(/\/:\w+/g, '')
  }

  const canRenderRoutePath = (routePath) => {
    if (!isRouteRestricted) return true
    if (ALWAYS_ALLOWED_ROUTES.has(routePath)) return true

    const base = routeToBasePath(routePath)
    if (!base) return false

    return allowedRoutes.some((allowed) => {
      if (allowed === base) return true
      if (base.startsWith(allowed + '/')) return true
      return false
    })
  }

  const renderAllowedRoute = ({
    path,
    element,
    errorElement,
  }) => {
    return canRenderRoutePath(path) ? (
      <Route
        path={path}
        element={element}
        errorElement={errorElement}
      />
    ) : null
  }

  const defaultAllowedRoute = isRouteRestricted
    ? allowedRoutes[0]
    : '/admin/orders'

  // #region agent log
  fetch('http://127.0.0.1:7311/ingest/88d91b5b-4de0-42e9-9d8c-86e7d0e1b935',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'13f5fa'},body:JSON.stringify({sessionId:'13f5fa',runId:'pre-fix',hypothesisId:'H1',location:'App.js:allowedRoutes',message:'Computed route restriction state',data:{hasAcc:!!acc,isRouteRestricted,allowedRoutesCount:allowedRoutes?.length??0,defaultAllowedRoute},timestamp:Date.now()})}).catch(()=>{});
  // #endregion

  const { data: siteParams, isSuccess } =
    mainApi.useGetSiteParamsByIdQuery(
      { _id: acc?.site ? acc?.site : '' },
      { skip: !acc?.site },
    )

  useEffect(() => {
    // Функция для обновления siteParams в localStorage
    const updateSiteParams = () => {
      if (isSuccess && siteParams) {
        // console.log('Updating siteParams:', siteParams)
        localStorage.setItem(
          'site',
          JSON.stringify(siteParams),
        )
      }
    }

    // Вызываем обновление каждые 30 минут (30 * 60 * 1000 миллисекунд)
    const interval = setInterval(
      () => {
        updateSiteParams()
      },
      30 * 60 * 1000,
    )

    // Запускаем обновление сразу при первом рендере
    updateSiteParams()

    // Очищаем интервал при размонтировании компонента
    return () => clearInterval(interval)
  }, [isSuccess, siteParams])

  //settings exp
  // const settings = useSelector((state) => state.userSettings.settings)

  // const [headerImage, setHeaderImage] = useState(settings.headerImage)
  // const [adminName, setAdminName] = useState(settings.adminName)

  // useEffect(() => {
  //   setHeaderImage(settings.headerImage)
  //   setAdminName(settings.adminName)
  // }, [settings])

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((reg) => console.log('Service Worker зарегистрирован!', reg))
        .catch((err) => console.log('Ошибка регистрации SW:', err));
    });
  }

  //WX+ZXyLEa5!3kBJf
  return (
    <ThemeProvider theme={theme}>
      <div className='App'>
        {location.pathname.split('/')[2] !== 'static' &&
            location.pathname.split('/')[2] !== 'magic' &&
            location.pathname.split('/')[1] !== 'buyerList' &&
          SUPPLIERS_LIST.some(
            (item) =>
              item.link !== location.pathname.split('/')[1],
          ) && <Header />}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ErrorBoundary>
            <PermissionsProvider>
              {/*<DebugPermissions />*/}
              {/*<PermissionsTest />*/}
              {/* {isAutorization && localStorage.getItem('password') === loginObj[localStorage.getItem('name')] ? ( */}
              {localStorage.getItem('acc') ? (
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route
                      path='/'
                      element={
                        <Navigate
                          replace
                          to={defaultAllowedRoute}
                        />
                      }
                      action={
                        isAutorization &&
                        password === 'WX+ZXyLEa5!3kBJf'
                          ? {}
                          : { replace: true, to: '/auth' }
                      }
                    />

                    <Route
                        errorElement={<ErrorBoundary />}
                        path='/admin/magic'
                        element={<MagicButton />}
                    />

                    {/* ОТКЛЮЧЕНО: проверка прав до переноса на backend */}
                    {renderAllowedRoute({ path: '/admin/orders', element: <Orders /> })}
                    {renderAllowedRoute({ path: '/welcome', element: <WelcomePage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/contacts', element: <Contacts />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/contactsStats', element: <ContactStats />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/orders/:id', element: <OrdersChange />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/contacts/:id', element: <ContactChange />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/catalog', element: <Catalog />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/catalogCompare', element: <CatalogMacroCompare />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/catalog/:id', element: <CatalogChange />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/history', element: <History />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/history/:search', element: <History />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/shipment', element: <ShipmentOrders />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/shopping', element: <ItemsProduction />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/buyer', element: <BuyerProduction />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/logistic', element: <Logistic />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/logistic/history', element: <LogisticHistory />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/MBApp', element: <MBAppPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/client/static/:id', element: <StaticPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/botTimer', element: <BotTimer />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/ordersHistory', element: <OrdersHistory />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/ordersHistory/:id', element: <OrdersChange />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/profile', element: <Profile />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/client/static/order/:id', element: <StaticOrderFP />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/logs', element: <LogsPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/catalogStats', element: <CatalogStats />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/prezo', element: <PrezoPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/noAccess', element: <NoAccess />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/picking', element: <PickingPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/searchingList', element: <SearchingListPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/addSite', element: <TestFunc />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/lowAnalyzer', element: <LowProfit />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/productsManager', element: <ProductsManager />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/productsManager/history', element: <ProductsManagerHistory />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/productsManager/history/:params', element: <ProductsManagerHistory />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/stock', element: <StockProduction />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/salesforCom', element: <SalesForCom />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/debtors', element: <DebtorsPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/year', element: <ResultsPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/spoManagement', element: <SpoManager />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/messages', element: <MessagesPage />, errorElement: <ErrorBoundary /> })}
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='*'
                      element={
                        isRouteRestricted ? (
                          <Navigate
                            replace
                            to={defaultAllowedRoute || '/admin/noAccess'}
                          />
                        ) : (
                          <SpoManager />
                        )
                      }
                    />

                    {renderAllowedRoute({ path: '/admin/juice', element: <JuiceProduction />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/supDebt', element: <SuppliersDebtorsPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/meetings', element: <MeetingPage />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/vacations', element: <Vacation />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/management', element: <Management />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/admin/telegram-visits-map', element: <TelegramVisitsMap />, errorElement: <ErrorBoundary /> })}
                    {renderAllowedRoute({ path: '/juice', element: <JuiceProduction />, errorElement: <ErrorBoundary /> })}
                    {SUPPLIERS_LIST.map((el) => (
                      <React.Fragment key={el.link}>
                        {renderAllowedRoute({ path: '/' + el.link, element: <SuppliersProduction item={el} />, errorElement: <ErrorBoundary /> })}
                        {renderAllowedRoute({ path: '/admin/' + el.link, element: <SuppliersProduction item={el} />, errorElement: <ErrorBoundary /> })}
                      </React.Fragment>
                    ))}
                    {renderAllowedRoute({ path: '/buyerList', element: <BuyerListProduction />, errorElement: <ErrorBoundary /> })}
                  </Routes>
                </Suspense>
              ) : (
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route
                      path='/'
                      element={
                        <Navigate replace to='/auth' />
                      }
                    />
                    <Route
                      path='/auth'
                      element={
                        // <OldAutorization
                        //   loginObj={loginObj}
                        //   name={name}
                        //   setName={setName}
                        //   password={password}
                        //   setPassword={setPassword}
                        //   setIsAutorization={setIsAutorization}
                        // />
                        <Autorization />
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/botTimer'
                      element={<BotTimer />}
                    />

                    <Route
                        errorElement={<ErrorBoundary />}
                        path='/admin/magic'
                        element={<MagicButton />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/juice'
                      element={<JuiceProduction />}
                    />
                    {SUPPLIERS_LIST.map((el) => (
                      <Route
                        key={el.link}
                        errorElement={<ErrorBoundary />}
                        path={'/' + el.link}
                        element={
                          <SuppliersProduction item={el} />
                        }
                      />
                    ))}
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/buyerList'
                      element={<BuyerListProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/*'
                      element={<StaticPage />}
                    />
                    <Route
                      path='*'
                      element={
                        <Navigate replace to='/auth' />
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/productsManager/history'
                      element={<ProductsManagerHistory />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/productsManager/history/:params'
                      element={<ProductsManagerHistory />}
                    /> 
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/order/:id'
                      element={<StaticOrderFP />}
                    />
                  </Routes>
                </Suspense>
              )}
            </PermissionsProvider>
          </ErrorBoundary>
        </LocalizationProvider>
      </div>
    </ThemeProvider>
  )
}

export default App
